import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWallet = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1.125em",
	height: "1.125em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20 9.00044C20 8.44815 19.5523 8.00044 19 8.00044H5C4.44772 8.00044 4 8.44815 4 9.00044V19.0004C4.00024 19.5525 4.44786 20.0004 5 20.0004H19C19.5521 20.0004 19.9998 19.5525 20 19.0004V9.00044ZM16.0098 13.0004C16.5621 13.0004 17.0098 13.4482 17.0098 14.0004C17.0095 14.5525 16.5619 15.0004 16.0098 15.0004H16C15.4479 15.0004 15.0002 14.5525 15 14.0004C15 13.4482 15.4477 13.0004 16 13.0004H16.0098ZM10.4668 6.00044H18V3.40278L10.4668 6.00044ZM20 6.17427C21.1646 6.58642 22 7.69464 22 9.00044V19.0004C21.9998 20.6571 20.6567 22.0004 19 22.0004H5C3.34329 22.0004 2.00024 20.6571 2 19.0004V9.00044C2 7.74157 2.77577 6.66433 3.875 6.21919C3.96213 6.14944 4.06227 6.09262 4.17383 6.05415L17.3477 1.51216C18.6464 1.06431 20 2.02898 20 3.40278V6.17427Z",
		fill: "currentColor"
	})
});
export default SvgWallet;
